import { MantineTheme } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { FC } from "react";

const useStyles = createStyles((_theme: MantineTheme) => ({
  checkboxContainer: {
    width: "247px",
    height: "20px",
    marginBottom: "6px",
  },
}));

type Props = {};

const EmptyDiv: FC<Props> = (_props) => {
  const { classes } = useStyles();
  return <div className={classes.checkboxContainer}></div>;
};

export default EmptyDiv;
